import { lazy } from "react"

export const TenantLogin = lazy(() => import("./tenant-login"))
export const TenantNotFound = lazy(() => import("./tenant-not-found"))
export const TenantSignup = lazy(() => import("./tenant-signup"))
export const TenantSignupInfo = lazy(() => import("./tenant-signup-info"))
export const TenantEmailNotVerified = lazy(() => import("./tenant-email-not-verified"))
export const TenantForgotPassword = lazy(() => import("./tenant-forgot-password"))
export const TenantForgotPasswordSent = lazy(() => import("./tenant-forgot-password-sent"))
export const TenantResetPassword = lazy(() => import("./tenant-reset-password"))
export const TenantDashboard = lazy(() => import("./tenant-dashboard"))
export const TenantTicketList = lazy(() => import("./tenant-ticket-list"))
export const TenantTicketCreate = lazy(() => import("./tenant-ticket-create"))
export const TenantTicketDetail = lazy(() => import("./tenant-ticket-detail"))
export const TenantTicketEdit = lazy(() => import("./tenant-ticket-edit"))
export const TenantTicketPreview = lazy(() => import("./tenant-ticket-preview"))
export const TenantSales = lazy(() => import("./tenant-sales"))
export const TenantShopSettings = lazy(() => import("./tenant-shop-settings"))
export const TenantMembers = lazy(() => import("./tenant-members"))
export const TenantMemberAdd = lazy(() => import("./tenant-member-add"))
export const TenantMemberEdit = lazy(() => import("./tenant-member-edit"))
export const TenantTicketSettings = lazy(() => import("./tenant-ticket-settings"))
